@if(currentLegData){
<div class="eye-view-details mb-1">
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Container Job Number
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.containerJobNumber}}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Freight Payer
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.freightPayerName}}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Container Number
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.containerNumber}}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Order Number
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.orderNumber}}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            TSW ID
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.tswId}}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            ECN
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.ecn}}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end eye-view-details-header">
            Customer Reference
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.customerReference}}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Container Type
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.containerType }}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Gauge
        </div>
        <div class="col-7 eye-view-details-content">
            {{showGaugeTypes()}}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Container Size
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.containerSize }}
        </div>
    </div>
</div>
<div class="eye-view-details mb-1">
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Weight (kg)
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.weight }}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Temperature
        </div>
        <div class="col-7 eye-view-details-content">
            {{
            getTemperature(currentLegData.temperature)}}
        </div>
    </div>
    @if(isInboundJob || isIntermodalJob){
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Acceptance Number
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.acceptanceNumber}}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Is Acceptance Active
        </div>
        <div class="col-7 eye-view-details-content">
            {{currentLegData.isAcceptanceActive ? 'Yes' :
            'No'}}
        </div>
    </div>
    }

    @if(!isInboundJob || isIntermodalJob){
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Release Number
        </div>
        <div class="col-7 eye-view-details-content">
            {{currentLegData.releaseCode }}
        </div>
    </div>
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Is Release Active
        </div>
        <div class="col-7 eye-view-details-content">
            {{currentLegData.isReleaseActive ? 'Yes' :
            'No'}}
        </div>
    </div>
    }

    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            First Notified Date
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.firstNotifiedDate | date: 'dd/MM/yyyy h:mm a' }}
        </div>
    </div>

    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Document Recieved Date
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.docsReceivedDate | date: 'dd/MM/yyyy h:mm a'}}
        </div>
    </div>

    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Live Unload
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.liveUnload }}
        </div>
    </div>

    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            MPI Inspection
        </div>
        <div class="col-7 eye-view-details-content">
            {{currentLegData.mpiInspectionRequired ? 'Yes' : 'No'}}
        </div>
    </div>

    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Seal #
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.sealNumber }}
        </div>
    </div>

    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Requires X-ray
        </div>
        <div class="col-7 eye-view-details-content">
            {{currentLegData.requiresXray ? 'Yes' : 'No'}}
        </div>
    </div>

    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Requires Weigh
        </div>
        <div class="col-7 eye-view-details-content">
            {{currentLegData.requiresWeigh ? 'Yes' : 'No'}}
        </div>
    </div>
</div>
<div class="eye-view-details mb-1">
    <div class="row eye-view-details-row">
        <div class="col-5 mogo-bold text-end text-end eye-view-details-header">
            Dangerous Goods
        </div>
        <div class="col-7 eye-view-details-content">
            {{ currentLegData.dgCode }}
        </div>
    </div>
</div>
}